import React, { createContext, useContext, ReactNode } from 'react';
import { Session, StaticVideo } from 'types/working-model';
import { useSessionStaticVideos } from 'hooks/session-static-videos.hooks';

interface SessionContextType {
  session: Session;
  onDemandVideo: StaticVideo | null | undefined;
  loadingVideos: boolean;
}

const SessionContext = createContext<SessionContextType | null>(null);

interface SessionProviderProps {
  session: Session;
  language: string;
  children: ReactNode;
}

export const SessionProvider: React.FC<SessionProviderProps> = ({ session, language, children }) => {
  const { currentVideo: onDemandVideo, loadingVideos } = useSessionStaticVideos(session, language);

  const value = {
    session,
    onDemandVideo,
    loadingVideos
  };

  return (
    <SessionContext.Provider value={value}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSessionContext = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
}; 